module.exports = __webpack_public_path__ + "media/images/thumb/map-close-75cfa7923529fbcb15e2e780c1ee8f24.png";